import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/about-cookies/page.tsx");
